<template>
  <BasePopup
    :visible="visible"
    popupClass="delete-confirm-popup"
    :showCloseBtn="false"
    :maskClosable="true"
    @close="handleCancel"
  >
    <div class="delete-confirm-container">
      <div class="delete-confirm-title"></div>
      <div class="delete-confirm-text">刪除該創作內容？</div>
      <div class="delete-confirm-actions">
        <div class="delete-confirm-btn" @click="handleConfirm"></div>
        <div class="delete-cancel-btn" @click="handleCancel"></div>
      </div>
    </div>
  </BasePopup>
</template>

<script setup>
import BasePopup from "./BasePopup.vue";

// Props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "确认删除",
  },
  message: {
    type: String,
    default: "确定要删除这个作品吗？删除后无法恢复。",
  },
  confirmText: {
    type: String,
    default: "确定",
  },
  cancelText: {
    type: String,
    default: "取消",
  },
});

// Emits
const emit = defineEmits(["close", "update:visible", "confirm", "cancel"]);

// 确认删除
const handleConfirm = () => {
  emit("confirm");
  emit("update:visible", false);
};

// 取消删除
const handleCancel = () => {
  emit("cancel");
  emit("close");
  emit("update:visible", false);
};
</script>
